// The page root is stretched to the viewport (same trick as TessellDeployments)
// so the frame card can claim whatever height is left below the header.
// No vertical margin on the root: .content is exactly 100vh and any extra
// would produce an outer scrollbar.
export const styles = {
  root: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    m: "0 16px 0 5px",
    pt: "8px",
    pb: "12px",
  },
  topRow: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "16px",
    flexShrink: 0,
  },
  hint: (colors) => ({
    display: "flex",
    alignItems: "center",
    gap: "6px",
    mb: "10px",
    fontSize: 12,
    color: colors.grey[400],
    flexShrink: 0,
  }),
  // Mirrors simpleCardStyle without its padding/height so the iframe can
  // fill the card edge to edge. overflow:hidden clips the frame to the
  // rounded corners and guarantees the card itself never scrolls.
  frameCard: (colors) => ({
    flex: 1,
    minHeight: 0,
    position: "relative",
    overflow: "hidden",
    borderRadius: "8px",
    border: `1px solid ${colors.grey[800]}`,
    backgroundColor: colors.primary[700],
    boxShadow: "0 1px 4px rgba(31,41,55,0.06)",
  }),
  // IframeViewer fills the whole card; its own inner styling handles the
  // actual <iframe> element (width/height/border/background).
  iframeViewer: {
    width: "100%",
    height: "100%",
  },
  overlay: (colors) => ({
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.primary[700],
    zIndex: 1,
  }),
  fallback: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    maxWidth: 420,
    px: "24px",
    gap: "8px",
  },
  fallbackIcon: (colors) => ({
    fontSize: 32,
    color: colors.grey[400],
  }),
  fallbackTitle: (colors) => ({
    color: colors.grey[100],
    fontSize: 15,
    fontWeight: 600,
  }),
  fallbackBody: (colors) => ({
    color: colors.grey[400],
    fontSize: 12.5,
    lineHeight: 1.5,
  }),
  fallbackActions: {
    display: "flex",
    gap: "8px",
    mt: "8px",
  },
};
